import { hasCookieAccess } from '../../utility/k_error';

const localStorageMap: { [key: string]: any } = {};

const qlubLocalStorageSet = (key: string, value: any) => {
    if (hasCookieAccess()) {
        localStorage.setItem(key, value);
    }
    localStorageMap[key] = value;
};

const qlubLocalStorageGet = (key: string) => {
    if (hasCookieAccess()) {
        return localStorage.getItem(key);
    }
    return localStorageMap[key];
};

const qlubLocalStorageRemove = (key: string) => {
    if (hasCookieAccess()) {
        localStorage.removeItem(key);
    }
    delete localStorageMap[key];
};

const qlubLocalStorageGetAll = () => {
    if (hasCookieAccess()) {
        return { ...localStorage };
    }
    return localStorageMap;
};

export const qlubLocalStorage = {
    set: qlubLocalStorageSet,
    get: qlubLocalStorageGet,
    remove: qlubLocalStorageRemove,
    getAll: qlubLocalStorageGetAll,
};
